<template>
  <div class="Main">
    <el-menu
      :default-active="navLeftActive"
      class="el-menu-demo TopMenu"
      active-text-color="#fff"
      mode="horizontal"
      active-background-color="#fff"
      :text-color="color"
      :router="true"
      :collapse-transition="false"
      @select="handleSelect"
    >
      <template v-for="(item, index) in routerList">
        <el-submenu
          :index="item.path"
          :key="index"
          v-if="item.children.length != 1"
          class="submenu"
        >
          <template slot="title">
            <!-- <i class="marginRight svgI" :style="{ color: color }">
              <svg-icon
                :data_iconName="item.meta.icon"
                :className="item.meta.icon + '_icon'"
                class="svgIcon"
            /></i> -->
            <span slot="title">{{ item.meta.title }}</span>
          </template>
          <div v-for="(itm, inx) in item.children" :key="inx">
            <el-menu-item :index="itm.path" v-if="!itm.children"
              ><template slot="title">
                <!-- <i>
                <svg-icon :data_iconName="itm.meta.icon" :className="itm.meta.icon+'_icon'" class="svgIcon"
              /></i> -->
                <!-- <a :href="itm.meta.href" v-if="itm.meta.href"><span slot="title">{{ itm.meta.title }}</span></a> -->
                <span slot="title">{{ itm.meta.title }}</span>
              </template>
            </el-menu-item>
            <el-submenu :index="itm.path" :key="inx" class="submenu" v-else>
              <template slot="title">
                <span slot="title" class="secondTitle">{{
                  itm.meta.title
                }}</span>
              </template>
              <el-menu-item
                :index="it.path"
                v-for="(it, ix) in itm.children"
                :key="ix"
                ><template slot="title">
                  <!-- <i>
                <svg-icon :data_iconName="it.meta.icon" :className="it.meta.icon+'_icon'" class="svgIcon"
              /></i> -->
                  <!-- <a :href="itm.meta.href" v-if="itm.meta.href"><span slot="title">{{ itm.meta.title }}</span></a> -->
                  <span slot="title" class="thirdTitle">{{
                    it.meta.title
                  }}</span>
                </template>
              </el-menu-item>
            </el-submenu>
          </div>
          <!-- <el-menu-item
            :index="itm.path"
            v-for="(itm, inx) in item.children"
            :key="inx"
            style="background: white"
            >{{ itm.meta.title }}</el-menu-item
          > -->
        </el-submenu>
        <!-- <el-menu-item
          :index="item.children[0].path"
          v-if="item.children.length == 1 && item.name == 'homeView'"
          :key="index"
          style="width: 27%"
        >
          <span slot="title"
            ><img :src="item.meta.img" alt="" style="width: 100%"
          /></span>
        </el-menu-item> -->
        <el-menu-item
          :index="item.children[0].path"
          v-if="item.children.length == 1"
          :key="index"
        >
          <!-- <i class="marginRight svgI" :style="{ color: color }">
            <svg-icon
              :data_iconName="item.meta.icon"
              :className="item.meta.icon + '_icon'"
              class="svgIcon"
          /></i> -->
          <span slot="title">{{ item.meta.title }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
  export default {
    name: "MenuTab",
    props: {
      color: {
        type: String,
        default: "#000",
      },
    },
    data() {
      return {
        routerList: [],
      };
    },
    components: {
      //引入模块
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
        /* if(this.$route.path==key){
        location.reload()
        this.$router.go(0)
      } */
      },
      getMenuLinks: function () {
        var t = this.$router.options.routes.filter(function (val, index, arr) {
          // console.log(val, index, arr)
          if (val.name != "detail" && val.name != "MD5") {
            return val.children;
          }
        });
        this.routerList = t;
        // console.log(t)
        //t returns a vue object instance
        // return t._children ;
        // did not know how to iterate this
      },
    },
    watch: {
      // watch擅长处理的场景：一个数据影响多个数据
    },
    computed: {
      // computed擅长处理的场景：一个数据受多个数据影响
      navLeftActive: function () {
        console.log(this.$route);
        const { meta, path } = this.$route;
        console.log(path, 111);
        if (meta.activeMenu) {
          return meta.activeMenu;
        }
        return path; //"/" + path.split("/")[1];
      },
    },
    beforeCreate: function () {
      // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
    },
    created: function () {
      // 实例已经创建完成之后被调用。在这一步，实例已完成以下的配置：数据观测(data observer)，属性和方法的运算， watch/event 事件回调。然而，挂载阶段还没开始，el 属性目前不可见。
    },
    beforeMount: function () {
      // 在挂载开始之前被调用：相关的 render 函数首次被调用。
    },
    mounted: function () {
      // 编译好的HTML挂载到页面完成后执行的事件钩子
      // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
      // 此钩子函数中一般会做一些ajax请求获取数据进行数据初始化
      this.getMenuLinks();
    },
    beforeUpdate: function () {
      // 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
    },
    updated: function () {
      // 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
      // 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。然而在大多数情况下，你应该避免在此期间更改状态，因为这可能会导致更新无限循环。
      // 该钩子在服务器端渲染期间不被调用。
    },
    beforeDestroy: function () {
      // 实例销毁之前调用。在这一步，实例仍然完全可用。
    },
    destroyed: function () {
      // Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，所有的事件监听器会被移除，所有的子实例也会被销毁。 该钩子在服务器端渲染期间不被调用。
    },
  };
</script>
<style scoped>
  .Main >>> .el-menu-item {
    /* width: 115px; */
    width: 185px;
    text-align: center;
    color: black !important;
    font-weight: bold;
    padding: 0 !important;
    /* height: 50px; */
    /* line-height: 50px; */
    /* background: transparent !important; */
    /* width: 160px; */
    /* text-align: center; */
  }
  .el-submenu >>> .el-submenu__title {
    /* height: 80px !important; */
    /* line-height: 80px !important; */
    /* width: 150px; */
    /* text-align: center; */
  }
  /* @media screen and (max-width: 1440px) {
  .Main >>> .el-menu-item {
    padding: 0 20px !important;
  }
} */

  .Main >>> .el-submenu__title {
    color: white !important;
    font-weight: bold;
    font-size: 20px !important;
    background: #6b8799 !important;
    margin-right: 5px;
    width: 185px;
    /* width: 177px; */
    text-align: center;
    padding: 0 !important;
    /* height: 50px !important; */
    /* line-height: 50px !important; */
  }
  .Main >>> .el-submenu__title:hover {
    background: #6b8799 !important;
    /* text-decoration: underline; */
    color: #f6bc1b !important;
    /* transform: scale(1.2); */
  }
  .Main >>> .el-menu-item.is-active {
    background: #6b8799 !important;
    border-bottom-color: #918f1d !important;
    /* border: 0; */
    /* color: #fff !important; */
  }
  .Main >>> .el-submenu__title.is-active {
    background: rgb(0 0 0 / 0%) !important;
    /* color: #fff !important; */
  }
  .TopMenu {
    border-bottom: 0 !important;
    background: transparent !important;
    /* margin-left:100px !important; */
  }
  .svgI {
    font-size: 20px;
    margin-right: 5px !important;
    color: currentColor !important;
  }
  .el-menu--horizontal .el-menu-item,
  .secondTitle {
    /* background: white !important; */
    color: #303133 !important;
    font-size: 20px !important;
  }
  .el-menu--horizontal .el-menu-item:hover {
    background: #6b8799 !important;
    /* text-decoration: underline; */
    color: #f6bc1b !important;
    /* transform: scale(1.2); */
  }
  .el-menu--popup .el-menu-item:hover {
    background: white !important;
    font-weight: bold;
    /* color: black !important; */
  }
  .Main >>> .el-submenu__title .el-icon-arrow-down:before {
    background: url("@/assets/down.png");
    background-size: 100%;
    background-repeat: no-repeat;
    color: transparent;
  }
  .Main >>> .el-submenu__title .el-submenu__icon-arrow {
    margin-left: 5px !important;
  }
</style>
<style scoped>
  /* .el-menu--horizontal {
  background: white !important;
} */
</style>
